module.exports = __webpack_public_path__ + "media/icons/confidential-leave-planning-744446c1.svg";